export default __webpack_public_path__ + "static/media/mark-text.7e255252.svg";